export  function isSameDay(date, otherDate) {
    // 获取当前日期的年、月、日
    var currentYear = otherDate.getFullYear();
    var currentMonth = otherDate.getMonth();
    var currentDate = otherDate.getDate();
    // 获取给定时间戳的年、月、日
    var year = date.getFullYear();
    var month = date.getMonth();
    var day = date.getDate();
    //不是同一天
    return !(currentYear === year && currentMonth === month && currentDate === day);
}